module.exports = __webpack_public_path__ + "static/media/tab-my.63bd5549.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/tab-my.png
// module id = 2027
// module chunks = 6